import React from 'react'
import { Typography, Grid, Paper, Box } from '@mui/material'
import BusinessCardSquare from '../BusinessCardSquare'
import { styled } from '@mui/material/styles'
import Button from 'components/Common/Button'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const CurrentlyFollowingBox = styled(Paper)(({ theme }) => ({
  marginTop: '20px',
  width: '300px',
  height: '270px',
  boxShadow: '4px 4px 15px rgba(10, 120, 205, 0.08)',
  borderRadius: '10px',
}))

const sx = {
  flexBoxLine: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#25245F',
    marginTop: '30px',
  },
  noPadding: {
    paggingBottom: 0,
  },
}


const BusinessList = ({ models, onCardRemoveClick, isMonitored }) => {
  const navigate = useNavigate()
  const userInfo = useSelector(state => state.userReducer.user)

  return (
    <>
      {(models?.length > 0 || (models?.length === 0 && userInfo?.accountType === 'free')) && (
        <Grid item xs={12} classes={{ root: sx.noPadding }}>
          <Box sx={sx.flexBoxLine}>
            <Typography variant="h6">Currently Following</Typography>
          </Box>
        </Grid>
      )}
      {models?.length === 0 && userInfo?.accountType === 'free' && (
        <Box px={2} width={'100%'} marginBottom="20px" color="#25245f">
          <CurrentlyFollowingBox>
            <Box display="flex" justifyContent="center">
              <Typography variant="body1M" align="center" color="secondary" margin="22% 15% 7% 15%">
                Become a premium member to follow other businesses
              </Typography>
            </Box>
            <Box display="flex" justifyContent="center">
              <Button style={{ width: '230px' }} onClick={() => navigate('/welcome')}>
                Upgrade
              </Button>
            </Box>
          </CurrentlyFollowingBox>
        </Box>
      )}
      {models.map(model => (
        <Grid key={model.businessId} item xs={12} sm={6} md={3.5} color="#25245f">
          <BusinessCardSquare model={model} onRemoveClick={onCardRemoveClick} isMonitored={isMonitored} />
        </Grid>
      ))}
    </>
  )
}

export default BusinessList
